import React, {useState} from "react";
import styles from "./SetPasswordComponent.module.css";
import PasswordValidator from "../../utils/PasswordValidator/PasswordValidator";
import {updatePassword} from "../../api/AuthApi";
import {useLocation, useNavigate} from "react-router-dom";

const SetPasswordComponent: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const [oldPasswordError, setOldPasswordError] = useState(false);
    const [newPasswordError, setNewPasswordError] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);

    const isPasswordValid = () => {
        const passwordValidationRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
        return passwordValidationRegex.test(newPassword);
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        setMessage(null);
        setOldPasswordError(false);
        setNewPasswordError(false);
        setConfirmPasswordError(false);

        if (!password) {
            setMessage("Enter old password.");
            setOldPasswordError(true);
            return;
        }

        if (!isPasswordValid()) {
            setMessage("The new password does not meet the requirements.");
            setNewPasswordError(true);
            return;
        }

        if (newPassword !== confirmPassword) {
            setMessage("Passwords do not match!");
            setNewPasswordError(true);
            setConfirmPasswordError(true);
            return;
        }

        try {
            await updatePassword({password, newPassword});
            setSuccess(true);
            setMessage("Password updated successfully.");
        } catch (error: any) {
            if (error.message === "Invalid password.") {
                setOldPasswordError(true);
                setMessage(null);
            } else {
                setMessage(error.message ?? "An error occurred. Please try again.");
            }
        }
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <nav className={styles.headerNav}>
            {location.pathname !== '/' && location.pathname !== '/login' &&
                renderButton("Back", handleGoHome)}
            <div className={styles.container}>
                <h1 className={styles.title}>Change Password</h1>
                {!success ? (
                    <>
                        <input
                            className={`${styles.input} ${oldPasswordError ? styles.inputError : ""}`}
                            type="password"
                            placeholder="Old Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {oldPasswordError && <p className={styles.error}>The old password is incorrect.</p>}

                        <input
                            className={`${styles.input} ${newPasswordError ? styles.inputError : ""}`}
                            type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <PasswordValidator password={newPassword}/>
                        {newPasswordError && <p className={styles.error}>The new password is invalid.</p>}

                        <input
                            className={`${styles.input} ${confirmPasswordError ? styles.inputError : ""}`}
                            type="password"
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        {confirmPasswordError && <p className={styles.error}>Passwords must match.</p>}

                        <button className={styles.button} onClick={handleSubmit}>
                            Update Password
                        </button>

                        {message && !oldPasswordError && !newPasswordError && !confirmPasswordError && (
                            <p className={styles.error}>{message}</p>
                        )}
                    </>
                ) : (
                    <p className={styles.success}>{message}</p>
                )}
            </div>
        </nav>
    );
};

const renderButton = (label: string, onClickHandler: () => void) => (
    <button className="btn btn-primary-light" onClick={onClickHandler}>{label}</button>
);

export default SetPasswordComponent;